import { BrandColorsTypes } from './types';
import BrandColorsItem from './brand-colors-item';
import BrandColorsExample from './brand-colors-example';

import cn from './styles.module.css';

const BrandColors = ({
  brandColor,
  setValue,
  companyName,
  headerLogo,
}: BrandColorsTypes) => (
  <div className={cn.brandColorsWrapper}>
    <div className={cn.brandColorsTitle}>Brand colors</div>
    <div className={cn.brandColorsHint}>
      Choose one primary color for your brand. Refer to the example on the right
    </div>
    <BrandColorsItem
      title="Brand color"
      color={brandColor}
      setValue={setValue}
    />
    {brandColor && (
      <BrandColorsExample
        color={brandColor}
        companyName={companyName}
        headerLogo={headerLogo}
      />
    )}
  </div>
);

export default BrandColors;
